import { v4 as uuid } from 'uuid';
import { md5 } from 'js-md5';
export class CartItem {
    id;
    productId = null;
    quantity = null;
    note = null;
    courseId = null;
    options = {};
    addons = [];
    chosen = {};
    serviceInformation = null;
    constructor(id, data) {
        this.id = id || uuid();
        if (data) {
            let definedKeys = Object.keys(this).filter((key) => key != "id");
            for (let key in data) {
                let value = data[key];
                let keyIsDefinedOnInstance = definedKeys.includes(key);
                if (keyIsDefinedOnInstance) {
                    if (value) {
                        //replace all firebase dates with real dates
                        if (value.seconds && value.toDate) {
                            value = value.toDate();
                        }
                    }
                    Object.assign(this, { [key]: value });
                }
            }
        }
    }
    getRelevantInfoHash() {
        let info = {
            productId: this.productId,
            note: this.note,
            courseId: this.courseId,
            chosen: this.chosen,
            addons: this.addons,
            options: this.options,
            serviceInformation: this.serviceInformation
        };
        console.log(JSON.stringify(info));
        return md5(JSON.stringify(info));
    }
    static accumulateByRelevantInfo(items) {
        let itemsByHash = {};
        if (items) {
            for (let item of items) {
                item = new CartItem(item.id, item);
                let hash = item.getRelevantInfoHash();
                if (!itemsByHash[hash]) {
                    itemsByHash[hash] = item;
                    item.quantity = 0;
                }
                itemsByHash[hash].quantity = itemsByHash[hash].quantity ? itemsByHash[hash].quantity + 1 : 1;
            }
        }
        return Object.values(itemsByHash);
    }
}
